import React, { useState, useEffect} from 'react';
import language from '../../../utils/LanguageSettings';
import { fetchSupportItems } from '../../functions/fetchSupport';
import '../../../css/support.css'
import { useParams } from 'react-router-dom';
import translations from '../../../text/get-started-translations.json';
import SupportTextEditor from './SupportTextEditor';
import SupportButtonTypeLinks from './SupportButtonTypeLinks';
import SupportLinksWithThumbnails from './SupportLinksWithThumbnails';
import SupportAccordion from './SupportAccordion';
import SupportAppsLayout from './SupportAppsLayout';
import SupportFeedBackPopup from './SupportFeedBackPopup';
import SupportThankYou from './SupportThankYou';
import SupportTab from './SupportTab';
import SupportSlider from './SupportSlider';
import SupportTwoColumnsLayout from './SupportTwoColumnsLayout';
import SupportDropdown from './SupportDropdown';
import RenderSnA from '../../functions/renderSnA';
import SupportContactUsLayout from './SupportContactUsLayout';
import SupportSuggestedArticlesLayout from './SupportSuggestedArticlesLayout';
import SupportButtonTypeExternalLink from './SupportButtonTypeExternalLink';
import Error404 from '../Error404';

interface SupportItemProps {

}

const SupportItem: React.FC<SupportItemProps> = () => {
    const pageTranslations = translations[language];
    const [loading, setLoading] = useState<boolean>(true);
    const [supportItemData, setSupportItemData] = useState<any>();
    const [Content, setContent] = useState<any[]>([]);
    const [seo, setSeo] = useState<any>(null);
    const [ga, setGa] = useState<any>(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
    const SupportItems: React.SetStateAction<any[]> = [];
    let Parents = new Array();
    const slug = useParams(); 

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth < 767);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
    
    useEffect(() => {
        const fetchData = async () => {
            let data = await fetchSupportItems(language);
            if(data?.data){
                data.data.forEach((element: { attributes: { slug: string | undefined; GA: any | null; SEO: any | null}; }) => {
                    if(element?.attributes?.slug == slug?.slug){
                        setSupportItemData(element?.attributes);
                        handleContent(element?.attributes);
                        setGa(element?.attributes?.GA || null);
                        setSeo(element?.attributes?.SEO || null);
                    }
                });
                setLoading(false);
            }
        };
        fetchData();
    }, [language]);

    const handleContent = (item: any) => {
        setContent([]);
        item.Content.forEach((element: {__component: string}, index: number) => {
            switch(element?.__component){
                case "support.text-editor":
                    SupportItems.push(<SupportTextEditor element={element} key={index}/>);
                    break;
                case "support.button-type-links":
                    SupportItems.push(<SupportButtonTypeLinks element={element}  key={index}/>);
                    break;
                case "support.links-with-thumbnails":
                    SupportItems.push(<SupportLinksWithThumbnails element={element}  key={index}/>);
                    break;
                case "support.apps-layout":
                    SupportItems.push(<SupportAppsLayout element={element} key={index} />);
                    break;
                case "support.accordion":
                    SupportItems.push(<SupportAccordion element={element}  key={index}/>);
                    break;
                case "support.tab":
                    SupportItems.push(<SupportTab element={element} key={index}/>);
                    break;
                case "support.slider":
                    SupportItems.push(<SupportSlider element={element} key={index}/>);
                    break;
                case "support.two-columns-layout":
                    SupportItems.push(<SupportTwoColumnsLayout element={element} key={index}/>);
                    break;
                case "support.dropdown":
                    SupportItems.push(<SupportDropdown element={element} key={index}/>);
                    break;
                case "support.contact-us-layout":
                    SupportItems.push(<SupportContactUsLayout element={element} key={index}/>);
                    break;
                case "support.suggested-articles-layout":
                    SupportItems.push(<SupportSuggestedArticlesLayout element={element} key={index}/>);
                    break;
                case "support.button-type-external-link":
                    SupportItems.push(<SupportButtonTypeExternalLink element={element} key={index} />);
                    break;
            }
        });
        setContent(SupportItems);
    }
    const handleMenu = () => {
        Parents = [];

        if (!supportItemData?.DisplayTitle) {
            Parents.unshift("" + "-->" + supportItemData?.Name);
        }
        if (supportItemData?.Parent?.data) {
            handleParents(supportItemData.Parent.data);
        }
        Parents.unshift("support" + "-->" + pageTranslations.support);
        return Array.isArray(Parents) && Parents.map((item, index) => (
            <li key={index}>
            {item.split("-->")[0] === "" ? (
                item.split("-->")[1]
            ) : (
                <a href={window.location.origin + "/" + item.split("-->")[0]}>
                {item.split("-->")[1]}
                </a>
            )}
            </li>
        ));
    };

    const handleParents = (parents: any) => {
        if (!parents) return;
        const slug = parents?.attributes?.slug;
        const name = parents?.attributes?.Name;
        if (slug && name) {
            Parents.unshift(
            slug.indexOf("?") > -1
                ? `${slug}-->${name}`
                : `support/${slug}-->${name}`
            );
        }
        if (parents?.attributes?.Parent?.data) {
            handleParents(parents.attributes.Parent.data);
        }
    };
    
    if (loading) {
        return (<>
            <div id="loader">
                <div className="spinner-border"></div>
            </div>
        </>
        );
    }
    if (!supportItemData){
        return <Error404 />
    }
    return (
      <>
        <RenderSnA seo={seo} ga={ga} />
            <input name="post_id" type="hidden" />
            <ul className="text-center category-breadcrumb">
                {handleMenu()}
            </ul>
            <section id="main-content" className="spacer-bottom support-items" style={isMobile ? {minHeight:"90vh"} : {minHeight:"70vh"}}>
                <div className="spacer-bottom support">
                    {supportItemData?.DisplayTitle ? <h1 className="h2 text-center spacer-top title-displayed font-medium">{supportItemData?.Name}</h1> :<></>}
                    {Content ? Content : <></>}
                </div>
                {supportItemData?.ShowArticleSurvey ? 
                    <div className="text-center is-article-helpful">
			            <div className="to-hide">
				            <p className="mr-sm-3 mr-0 d-sm-inline-block d-block barlow-font mb-4">{language == "en" ? "Was this article helpful?" : "此文章是否有幫助？"}</p>
				            <a href="#" className="d-inline-block mx-3 mb-3 sm_font_size barlow-font helpful">{language == "en" ? "Yes" : "是"}</a>
				            <a href="#" className="d-inline-block mx-3 sm_font_size barlow-font">{language == "en" ? "No" : "否"}</a>
                        </div>
		            </div> : <></> 
                }
                <SupportFeedBackPopup />
                <SupportThankYou />
            </section>
      </>
    );
};

export default SupportItem;